export default __webpack_public_path__ + "static/media/Maternity-Care-bg.2dd582af.svg";